/**
 * @file Human-readable labels for page workflow status and list filters.
 */
import type { PageStatus } from "@/lib/shared";

/** Labels for stored {@link PageStatus} values (badges, detail views). */
export const PAGE_STATUS_LABELS: Record<PageStatus, string> = {
  draft: "Draft",
  in_review: "In review (Not Live)",
  approved: "Approved",
  published: "Published",
  published_draft: "Published + draft changes",
  published_in_review: "Published + In review",
  unpublished: "Unpublished",
  rejected: "Rejected",
};

/** Labels for API list-filter sentinels (not stored on the page row). */
export const PAGE_FILTER_SENTINEL_LABELS = {
  reviewQueue: "In review (all)",
  publishedLive: "Published (live)",
} as const;

/**
 * Display label for a page status string from the API.
 */
export function getPageStatusLabel(status: string): string {
  if (status in PAGE_STATUS_LABELS) {
    return PAGE_STATUS_LABELS[status as PageStatus];
  }
  return status.replace(/_/g, " ");
}
